import React, { useState } from 'react';
import SideDrawerItems from './SideDrawerItems';
import Navbar from './NavBar';
import Backdrop from './../../shared/Backdrop';
import SideDrawer from './SideDrawer';
import MainHeader from './../MainHeader';

const Navigation = () => {

    const [drawerIsOpen, setDrawerIsOpen] = useState(false);

    const openDrawerHandler = () => setDrawerIsOpen(true);
    const closeDrawerHandler = () => setDrawerIsOpen(false)

    return ( 
        <div className="rtl">
            {drawerIsOpen && <Backdrop onClick={closeDrawerHandler} />}
                <SideDrawer show={drawerIsOpen} >
                <nav className="main-navigation__drawer-nav">
                    <SideDrawerItems closeSideDrawer={closeDrawerHandler}/>
                </nav>
            </SideDrawer>
            <MainHeader >
                <Navbar onShowDraw={openDrawerHandler}/>
            </MainHeader>
        </div>
    );
}
 
export default Navigation;